import { render, staticRenderFns } from "./SearchResults.vue?vue&type=template&id=e495384a&scoped=true&"
import script from "./SearchResults.vue?vue&type=script&lang=js&"
export * from "./SearchResults.vue?vue&type=script&lang=js&"
import style0 from "./SearchResults.vue?vue&type=style&index=0&id=e495384a&prod&lang=scss&"
import style1 from "./SearchResults.vue?vue&type=style&index=1&id=e495384a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e495384a",
  null
  
)

export default component.exports